export default __webpack_public_path__ + "static/media/oxeTechLabLogoON.2d8d8ccd.png";